<template>
  <transition
    enter-active-class="transform-gpu transition duration-300 ease-custom"
    enter-class="translate-y-1/2 scale-y-0 opacity-0"
    enter-to-class="translate-y-0 scale-y-100 opacity-100"
    leave-active-class="transform-gpu transition duration-300 ease-custom"
    leave-class="-translate-y-0 scale-y-100 opacity-100"
    leave-to-class="translate-y-1/2 scale-y-0 opacity-0"
  >
    <div
      v-show="openMenuNavbar"
      :class="$screen.portrait ? 'bottom-full' : 'bottom-16'"
      class="border-ontick-carbon-500 absolute left-6 z-50 mr-4 mt-2 w-56 rounded-md border text-gray-300 shadow-lg"
    >
      <div class="shadow-xs bg-ontick-steel-700">
        <div class="bg-ontick-steel-500 rounded-t-md px-4 py-3 shadow">
          <div class="flex">
            <span class="relative inline-block">
              <v-gravatar :size="60" :hash="user_picture" />
            </span>
            <div class="ml-3">
              <p class="pb-1 text-xs font-medium leading-5 text-white group-hover:text-white">
                {{ user }}
              </p>
              <dt class="bg-ontick-steel-500 flex w-full items-center rounded-b-md text-left text-xs text-gray-400">
                Código do usuário:

                <span class="text-ontick-blue-500 ml-1 font-semibold">
                  {{ user_code }}
                </span>
              </dt>
            </div>
          </div>
        </div>
        <router-link
          v-for="item in menu"
          class="relative"
          :key="item.tag"
          :to="{ name: 'Conta', query: { tag: item.tag } }"
          :class="[linkRouter, 'group']"
          @click.native="toggleMenuNavbar(item)"
        >
          <div class="relative flex items-center">
            <i v-html="item.icon" class="text-ontick-blue-500 demo:text-gray-500 mr-4"></i>
            <ontick-alert-badge class="-top-2 right-1" v-if="hasUnreadMessages && item.tag === 'messages'" />
          </div>
          <span>
            {{ item.name }}
          </span>
        </router-link>
        <a :class="[linkRouter, 'group']" target="_blank" href="https://ajuda.ontick.com.br/"
          ><span class="text-ontick-blue-500 demo:text-gray-500 mr-4" v-html="$icons.help"></span>Ajuda</a
        >

        <button
          class="bg-ontick-steel-600 inline-flex w-full items-center px-5 py-2 text-sm text-gray-400 hover:text-white"
          @click="signOut()"
        >
          <span class="text-ontick-blue-500 demo:text-gray-500 mr-3" v-html="$icons.logout"></span>
          Sair
        </button>
      </div>
    </div>
  </transition>
</template>

<script>
import EventBus from "../../utils/event_bus";
import { Auth } from "aws-amplify";
import Gravatar from "vue-gravatar";
import { mapGetters } from "vuex";

export default {
  props: {
    user: String,
    minimize: Boolean,
    user_picture: String,
    user_code: String,

    openMenuNavbar: {
      type: Boolean,
      default: false,
    },
  },

  components: {
    "v-gravatar": Gravatar,
  },

  data() {
    return {
      linkRouter:
        "group flex items-center px-4 py-2 text-sm leading-5 text-gray-400 hover:bg-ontick-steel-500 hover:text-white focus:outline-none focus:bg-ontick-dark-blue focus:text-white",

      menu: [
        { tag: "profile", icon: this.$icons.profile, name: "Meus Dados" },
        // { tag: "signature", icon: this.$icons.signature, name: "Assinaturas" },
        // { tag: "bindings", icon: this.$icons.bindings, name: "Vínculos" },
        // { tag: "plans", icon: this.$icons.plans, name: "Planos" },
        // { tag: "cards", icon: this.$icons.credit_card, name: "Cartão" },
        {
          tag: "messages",
          icon: this.$icons.email,
          name: "Mensagens",
        },
        {
          tag: "integration",
          icon: this.$icons.integration,
          name: "Segurança",
        },
        {
          tag: "preference",
          icon: this.$icons.more,
          name: "Outras opções",
        },
      ],
    };
  },

  computed: {
    ...mapGetters({ hasUnreadMessages: "config/hasUnreadMessages" }),
    // organiza 'menu' alfabeticamente
    sortedMenu() {
      return this.menu.sort((a, b) => {
        if (a.name < b.name) {
          return -1;
        }
        if (a.name > b.name) {
          return 1;
        }
        return 0;
      });
    },
  },

  methods: {
    toggleMenuNavbar(item) {
      this.openMenuNavbar = !this.openMenuNavbar;
      if (item) {
        if (item.tag) {
          EventBus.$emit("SELECTED_MENU", item.tag);
        }
      }
    },
    hide() {
      this.openMenuNavbar = false;
    },

    async signOut() {
      try {
        await Auth.signOut();
        this.worker.sendMessage({ type: "DISCONNECT" });
        sessionStorage.logout = true;
        this.$router.push({ path: "/auth" });
      } catch (error) {
        alert(error.message);
      }
    },
  },
};
</script>

<style></style>
